import React from 'react';

export default () => (
    <svg width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M33.4906 12.4L21.5072 11.3666L16.8239 0.333313L12.1406 11.3833L0.157227 12.4L9.25723 20.2833L6.52389 32L16.8239 25.7833L27.1239 32L24.4072 20.2833L33.4906 12.4ZM16.8239 22.6666L10.5572 26.45L12.2239 19.3166L6.69056 14.5166L13.9906 13.8833L16.8239 7.16665L19.6739 13.9L26.9739 14.5333L21.4406 19.3333L23.1072 26.4666L16.8239 22.6666Z" fill="#FFC632"/>
    </svg>
)